
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ogrBUd1iYS01XQwVEIHm1lZU1iCH1RRd52J9Zs174B5L0Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/og.vue?macro=true";
import { default as cartXAjJLx9b0aFymNcTQ_45_45UODNkrKB_5ZZ9r40edoeyELcMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/cart.vue?macro=true";
import { default as signsNDwOMzaqjKfmO4PsA8P_456mSf_45XKGb7kCKDGt8NN1AEMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/sign.vue?macro=true";
import { default as embedGZZhQ15GtYSBXQHjLnAfpYhMmsgkosDO0ucztjo8jp8Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/embed.vue?macro=true";
import { default as indexaw__45UBmLupASeiIM_g5slmjTw2qpFt0HDNZS3QFRyzsMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/index.vue?macro=true";
import { default as loginBgY1WunGGeghv9vVX6vcuurk54IBrMq6OEAiJx8QLY8Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/login.vue?macro=true";
import { default as resetIvBaqZXO51suJdmBkxncyY7NnKoUKzeZ4CwMxI0q1xgMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/reset.vue?macro=true";
import { default as termsXrUenpoMxSQnTGLWgz9kqw5Qwg21EJSBUVggbRHpR78Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/terms.vue?macro=true";
import { default as wheelgnK0pFsMJVv1agG8Jc0apDlpnbG0x8Jqrcw6LjIKSZwMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/wheel.vue?macro=true";
import { default as signuphaknYq_45WBWOygh3DVhCo9W1_45R1qopU7TUz1rsuKYKo0Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/signup.vue?macro=true";
import { default as verifyXa0y4AV_45xaUCM8O7eikpnmengKlBu0kHsObvCqlFyrYMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/verify.vue?macro=true";
import { default as auctionCUvCnQIlLM1qzPQN8bCPN9T3u_45ENilEt6Squsn4shOMMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/auction.vue?macro=true";
import { default as privacygr5uxBbXTvvpEdzDtmx1jx5km6T9tDxqudF8VJsdGs8Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/privacy.vue?macro=true";
import { default as Profile_MpYac0EnDANnzBkgVEdkx3Tbf6ejiX71E4ghB2h5iEMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/Profile.vue?macro=true";
import { default as _91_46_46_46all_93y7fdj04UswaRyJt0glRm_8vwK0wAMk4B4QJ3ruUVnykMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/[...all].vue?macro=true";
import { default as dj5305iwanx_45TgHBm3cInM392_451VyawsNcWIsxi5mP8IsMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/dj.vue?macro=true";
import { default as memoriamAYTFprf2ZcUMXYNoRIrd2l0ILMTsZJ0pEZTEXBP8NrQMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/memoriam.vue?macro=true";
import { default as indexCuroXEuZl7VQKyrhhg4Kq23CnN3EN7F2DJCCsaKiaZAMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/about/index.vue?macro=true";
import { default as admin_45loginY4qCf_45SmOaFqbZcA2vjPWPOrLwwI7cE2rQbiM_45tKHCwMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin-login.vue?macro=true";
import { default as index7WURel1cAAkvIobWJJse8DBShI8TjK1TahVcgFMR8NIMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/index.vue?macro=true";
import { default as notesBuMaYyOhJgqMjbm2hvhVWz_5Xo_45v3WD5NfbdPXuhgqUMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/notes.vue?macro=true";
import { default as teamsmwJf5hWQLyTI_Q28rkm2zmdrV_BLZVZaTBjOb3gAL6gMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/teams.vue?macro=true";
import { default as sentxmNqrpdOaGbICI_45YZ9X3wlZf_QyXWc3f5LAP0BlHchkMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/forgot/sent.vue?macro=true";
import { default as indexrcIfoFSDf0uNTAhRx3p_aHvY3dkxz8hCXWhXrFcSB88Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/rules/index.vue?macro=true";
import { default as guestsq2ybbmIa58Ts0NFTGh9HvOA3lCyIuXjE7LHi5Ca2aJ4Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/guests.vue?macro=true";
import { default as judgestils0lfNf_45dsEGR0GnpB2TkJY8x_kttOnC4bZbq7NLcMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/judges.vue?macro=true";
import { default as photosMBjDbHnaQ2BlVV_4504lSsjsq_O2tnWpEcUGTpzM8YE4MMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/photos.vue?macro=true";
import { default as scores_KxJtFxKxa_45UAPEMDwkL1cIQ7bqza3WSRFtOeGJ79WwMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/scores.vue?macro=true";
import { default as index2OD0APz3i8_45J6xWXcai5sY66m1Uvs5qIvnkr3687c_45oMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/causes/index.vue?macro=true";
import { default as indexYQ96CRDJqm2dLjEjpNL4IskWncfK3fGKPCYkFtx7KtsMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/donate/index.vue?macro=true";
import { default as indexNhHMLqrN074KI_f1KPfFlqQgA5mqrXNZwrr5fT0A5jkMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/forgot/index.vue?macro=true";
import { default as index1HYc3W_45uTKhWZHCVRP44nPMViG1LAXZUH3oGxAJG6HMMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/judges/index.vue?macro=true";
import { default as indexeNKDwroH7qRcyQO0tkA_kcP41IHQ_RnLLkdFVkbMoEUMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/system/index.vue?macro=true";
import { default as usersiU9ZD_45wuhKx_45Plc42o2wWmxRCqwWEZBmlz54n1JFVWwMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/system/users.vue?macro=true";
import { default as backzJU_457J19BFKxqmZ1n7T_45msoJJyn9_YjMf8AjnzONwNAMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/welcome/back.vue?macro=true";
import { default as teamykKNM0x3QdKU_45EWI7ilWG9efxVTtgHWsqqevEC4vaIcMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/welcome/team.vue?macro=true";
import { default as accept_45inviteR847aZX2c8ws5tHf19TLxxa7C_45w8wYvuxaJLKo8zEzwMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/accept-invite.vue?macro=true";
import { default as anglerslOQ9vGYpZw95pDskLCm2cm2SpyronklZ6KowoDqqj6AMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/anglers.vue?macro=true";
import { default as auctionGdo5nFhTSb0wx8ngrax8s3Khla2_45UIhkuWvWonHsCe4Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/auction.vue?macro=true";
import { default as pendingrnWmT90_45W3LDJrEzFalh03ETEKseTuSpnsqrvf8V924Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/pending.vue?macro=true";
import { default as rafflesNoEzYnPbfiUqPpJmQ7gqwyx6o17e1PDHfzjU21HAT3kMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/raffles.vue?macro=true";
import { default as winnersRpyUx6RLROk_45XmbsMLUVOh36fNYn_459rG6giOzTup9EgMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/winners.vue?macro=true";
import { default as indexDtvu0oHXDMLsGiDB9sbM18IYpgw_pWVDCIHLyLNWGKsMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/honoree/index.vue?macro=true";
import { default as guestsRr3dfGUgn9TUyIxDjgTSyBOlouiT3KZ0It5ih_45XrbZIMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/judges/guests.vue?macro=true";
import { default as indexdP4R1aFhMWEISVVQa3v3apv3EK0IIitNDZEDH1C6l6UMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/my-team/index.vue?macro=true";
import { default as index5uy6CeGXd8PUlxRLM9QTUrVm0583zRtCOr4yc2xHaawMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/raffles/index.vue?macro=true";
import { default as eventszYSADN7hQ3zsdoumzACZs9JgDl_45rDojfTgemNCPriocMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/system/events.vue?macro=true";
import { default as indexPCLeDtixZYjlLi15m0Ie9Omw5vBgbjep__2plyqv7p4Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/welcome/index.vue?macro=true";
import { default as index6SGyaWlhUqE2U8Pw02vB8gCpDgOjDLnOR6pzbi65R24Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/checkout/index.vue?macro=true";
import { default as _91token_93I0imRa9GtTJnGCGnEcqMWs05UJUrU4_k0oPnc_452oC6kMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/invite/[token].vue?macro=true";
import { default as anglersq1TLzyLeW9OY7x3VeUq7ejKR2pBbB2PS5vJ_YlddWnYMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/judges/anglers.vue?macro=true";
import { default as raffles9HR2LT8nw_Og233b7XhpNbVNAu_452My2GQmXbBdnY1bAMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/judges/raffles.vue?macro=true";
import { default as scoringZZktM9fHEOg9N3DE7STerszbn7ftvkThajb7jBibCJsMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/judges/scoring.vue?macro=true";
import { default as indexKF_8C3UIr2gLzbYITdwRx5Wt3gO3AlKgnRP_v0EwSKgMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/schedule/index.vue?macro=true";
import { default as dashboardeENnwqTvgTzkKXU6IdZT1SjD0Nn6iGyLu_wYuDBU3HYMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/dashboard.vue?macro=true";
import { default as indexl13FyZ6426JkKiuKnrA0SYuntyBjuy5q5JbAxz8VuLQMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/dashboard/index.vue?macro=true";
import { default as indexB9NYy_45_45XLIps4DRUut2BlGu2qbKLslDozUzdTs2dMHYMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/thank-you/index.vue?macro=true";
import { default as sponsorniUjU7fr84UC8jK_45Nz_ZLM1GpBnH2ngRCXOPMFEvgCgMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/welcome/sponsor.vue?macro=true";
import { default as checkout_confirmo7oxQQ4L8RQafxq7EagZINsCmOOR84HsvBB52YssQvcMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/checkout_confirm.vue?macro=true";
import { default as paymentX5aQAgRUUq1qiGbxFSgEhuvlUkrRVpKHYwI8lOGbDDkMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/checkout/payment.vue?macro=true";
import { default as backCVE1BYvI_o9QWW791ysiBsqbNgJLOsDiFDhNi40D_45QEMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/new-welcome/back.vue?macro=true";
import { default as teamkPIn64GmIPUrNOn9Qe2_Jw8O4FfMmxSD2cDb4_6Yo7wMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/new-welcome/team.vue?macro=true";
import { default as map6A_WM45sTWRGeXe7If6UjZnij0pKYeBE64ON0pmjIJ8Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/rules/map.vue?macro=true";
import { default as index_45N0e_4534jWyo9UfMUkLGIqju0zlVwjKzqWAydm9xZLMYMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/testMember/index.vue?macro=true";
import { default as tournamentscygxCB_45bYnMNYBDQ4uAqxH__45_45GZw3PTUbg5ecaw_5tAMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/tournaments.vue?macro=true";
import { default as indexCZhDpXlFXBs_M4FC2RCVPRZdXPqVVU1eP1h9qsdYbmEMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/leaderboard/index.vue?macro=true";
import { default as indexaKjeGipXtIVTgHBKXR0_ujdOrEb8PKbQV9hbeWw6ezkMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/new-welcome/index.vue?macro=true";
import { default as under_45maintenanceBR78sClA4guxcaS_rqc6sBdk28Pz0vYevDcXPFmztYIMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/under-maintenance.vue?macro=true";
import { default as participantsOXXuPHWgQZ7DtvvSoDDTfENT40CFV1VToFI87CRoTaYMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/participants.vue?macro=true";
import { default as indexWheaOfWjtFmrlGeaP5SOpliyXdiVieTgEfE3QNRRNQ8Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/rules/index.vue?macro=true";
import { default as announcementsaPxj_FGJpPXVqjbOo823av6sZ2U5U5MqNHaRr0X2P4sMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/announcements.vue?macro=true";
import { default as raffle_45buyersccOgCjQ0CozrdJyZVcVt7UoRUAkW0hOb5fD6yadKiNoMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/raffle-buyers.vue?macro=true";
import { default as reel_45of_45namesJL5tpfBF2OqshZVya2uR2k3eqmp_yjT_45VtNxtC8Z82AMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/reel-of-names.vue?macro=true";
import { default as indexFjLVLyLuNd0cuV28AQ19xn1G3SEMo6vby0ILsskrp7cMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/announcements/index.vue?macro=true";
import { default as team_45picker_45previewOfHqYTeDAykgq734NCwJkJsFm_45OQTuqrFF9PopB4g7cMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/team-picker-preview.vue?macro=true";
import { default as random_45winnerst0AxritM8Zj7zLTZNdY0VXQNCdzn6FRLitd_45eoyhY9oMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/random-winners.vue?macro=true";
import { default as _91token_93rAEwAEXIZMNZglAhDJZB6kLFmA5CVcbg97FNQlIZ0A8Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/invite/event/[token].vue?macro=true";
import { default as _91token_93flB_45mo28k2NkoUrWGjgi0g57FnrDvZoGFUU2ey9NA_45AMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/invite/judge/[token].vue?macro=true";
import { default as _91token_93MovRuF0T_45fIFnombBWv1RY_GZ_456RH4UX24TwML8a1swMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/invite/leader/[token].vue?macro=true";
import { default as _91token_93lt1qTgNRU6SCJ0Q2A1C734IcKop6Lp7lTjw2s7mJTloMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/invite/member/[token].vue?macro=true";
import { default as _91token_93BDpvEb7vma9lx_45T7jgzoyP12jPDLn3YeV1sblzEoJmwMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/invite/system/[token].vue?macro=true";
import { default as vendor_45inquiryJ18XWZX_45rVy07s5zTMOE6X3w1uiPbo_45Zy_45rweFacDGkMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/welcome/vendor-inquiry.vue?macro=true";
import { default as industry_45vendor2pSwBWhnU8AlJjkFFkEuP2d0xozSsm3Qlxy4E4HZO3MMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/welcome/industry-vendor.vue?macro=true";
import { default as tournament_45inviteslo27kKEV7_45KRn_CkV4G_45Ndt3fyAReiGUE34hVzzhBHoMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/tournament-invites.vue?macro=true";
import { default as indexnkJay2wS1ZYDfBCEQn_J64YiBrmQqayFcC1X8IIrh6UMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/leaderboard/index.vue?macro=true";
import { default as _91event_93zdUVOTBFZkCtVW6kzpapKN1L7GgjlFsJRxcL_45t_PEjwMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/leaderboard/[event].vue?macro=true";
import { default as _91id_93w2Qg4Fa9p8o2sZc91XxEnAgdjDiPWm_45xQDNGx60cH4gMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/raffle/[label]/[id].vue?macro=true";
import { default as overviewkSADNhXUgLrZ4nKyt6w7VTgEJ3fX_hkYv6VAfd7JU6YMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/registration/overview.vue?macro=true";
import { default as paymentsp3cucG9WDlAG4j4po4t7ynebWTVgzBVHQAg6hdsDtKYMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/registration/payments.vue?macro=true";
import { default as waitlistnqeJbD68oYzT31_45hGa7NvC_IKH9SRB2xT78emkPtjboMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/registration/waitlist.vue?macro=true";
import { default as industry_45vendorAZs_45p1U17T0EsMSucbxgQOUTpR4129N4PLxDpwyBC_45gMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/new-welcome/industry-vendor.vue?macro=true";
import { default as index4AQhR__454Zuo6u8fQQvaVvPZ49hyL7F7_W0gDdjR8X00Meta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/raffle/[label]/index.vue?macro=true";
import { default as donationsOgelWXY9DwQHfO4w6v34wujj_45Wy9FTRWcmxfU26h_yoMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/registration/donations.vue?macro=true";
import { default as indexcPcwOxuGARjQ2Zu7TQ_45TnP85c_ut4zObGzA0uXVxOqEMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/auction/[label]/index.vue?macro=true";
import { default as donor_45invitesGTBq3BbA30G9w_hJC8x91CrifK6LyK0_45OglZV8ab7tgMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/registration/donor-invites.vue?macro=true";
import { default as _91priority_93UtihjiD4VDCZ1dQwKkFoa0mUDYv8_45SIhXoRBM_45yzQ2cMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/auction/[label]/[priority].vue?macro=true";
import { default as vendor_45inquiriesoetnxe3hhKYP4voix0fUgqnpdHsS35f4U_45u3G5aQPVsMeta } from "/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/registration/vendor-inquiries.vue?macro=true";
export default [
  {
    name: "og",
    path: "/og",
    meta: ogrBUd1iYS01XQwVEIHm1lZU1iCH1RRd52J9Zs174B5L0Meta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/og.vue")
  },
  {
    name: "cart",
    path: "/cart",
    meta: {"middleware":["sponsor-only"]},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/cart.vue")
  },
  {
    name: "sign",
    path: "/sign",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/sign.vue")
  },
  {
    name: "embed",
    path: "/embed",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/embed.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexaw__45UBmLupASeiIM_g5slmjTw2qpFt0HDNZS3QFRyzsMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":["not-user-only"]},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/login.vue")
  },
  {
    name: "reset",
    path: "/reset",
    meta: {"middleware":["not-user-only"]},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/reset.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/terms.vue")
  },
  {
    name: "wheel",
    path: "/wheel",
    meta: wheelgnK0pFsMJVv1agG8Jc0apDlpnbG0x8Jqrcw6LjIKSZwMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/wheel.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: {"middleware":["not-user-only"]},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/signup.vue")
  },
  {
    name: "verify",
    path: "/verify",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/verify.vue")
  },
  {
    name: "auction",
    path: "/auction",
    meta: auctionCUvCnQIlLM1qzPQN8bCPN9T3u_45ENilEt6Squsn4shOMMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/auction.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/privacy.vue")
  },
  {
    name: "Profile",
    path: "/Profile",
    meta: {"middleware":["user-only"]},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/Profile.vue")
  },
  {
    name: "all",
    path: "/:all(.*)*",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/[...all].vue")
  },
  {
    name: "admin-dj",
    path: "/admin/dj",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/dj.vue")
  },
  {
    name: "memoriam",
    path: "/memoriam",
    meta: memoriamAYTFprf2ZcUMXYNoRIrd2l0ILMTsZJ0pEZTEXBP8NrQMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/memoriam.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/about/index.vue")
  },
  {
    name: "admin-login",
    path: "/admin-login",
    meta: {"middleware":["not-user-only"]},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin-login.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(index7WURel1cAAkvIobWJJse8DBShI8TjK1TahVcgFMR8NIMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: { ...(notesBuMaYyOhJgqMjbm2hvhVWz_5Xo_45v3WD5NfbdPXuhgqUMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/notes.vue")
  },
  {
    name: "admin-teams",
    path: "/admin/teams",
    meta: { ...(teamsmwJf5hWQLyTI_Q28rkm2zmdrV_BLZVZaTBjOb3gAL6gMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/teams.vue")
  },
  {
    name: "forgot-sent",
    path: "/forgot/sent",
    meta: {"middleware":["not-user-only"]},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/forgot/sent.vue")
  },
  {
    name: "rules",
    path: "/rules",
    meta: { ...(indexrcIfoFSDf0uNTAhRx3p_aHvY3dkxz8hCXWhXrFcSB88Meta || {}), ...{"middleware":["invited-to-year-only","dashboard"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/rules/index.vue")
  },
  {
    name: "admin-guests",
    path: "/admin/guests",
    meta: { ...(guestsq2ybbmIa58Ts0NFTGh9HvOA3lCyIuXjE7LHi5Ca2aJ4Meta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/guests.vue")
  },
  {
    name: "admin-judges",
    path: "/admin/judges",
    meta: { ...(judgestils0lfNf_45dsEGR0GnpB2TkJY8x_kttOnC4bZbq7NLcMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/judges.vue")
  },
  {
    name: "admin-photos",
    path: "/admin/photos",
    meta: { ...(photosMBjDbHnaQ2BlVV_4504lSsjsq_O2tnWpEcUGTpzM8YE4MMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/photos.vue")
  },
  {
    name: "admin-scores",
    path: "/admin/scores",
    meta: { ...(scores_KxJtFxKxa_45UAPEMDwkL1cIQ7bqza3WSRFtOeGJ79WwMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/scores.vue")
  },
  {
    name: "causes",
    path: "/causes",
    meta: index2OD0APz3i8_45J6xWXcai5sY66m1Uvs5qIvnkr3687c_45oMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/causes/index.vue")
  },
  {
    name: "donate",
    path: "/donate",
    meta: indexYQ96CRDJqm2dLjEjpNL4IskWncfK3fGKPCYkFtx7KtsMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/donate/index.vue")
  },
  {
    name: "forgot",
    path: "/forgot",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/forgot/index.vue")
  },
  {
    name: "judges",
    path: "/judges",
    meta: { ...(index1HYc3W_45uTKhWZHCVRP44nPMViG1LAXZUH3oGxAJG6HMMeta || {}), ...{"middleware":["invited-to-year-only","judge-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/judges/index.vue")
  },
  {
    name: "system",
    path: "/system",
    meta: { ...(indexeNKDwroH7qRcyQO0tkA_kcP41IHQ_RnLLkdFVkbMoEUMeta || {}), ...{"middleware":["system-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/system/index.vue")
  },
  {
    name: "system-users",
    path: "/system/users",
    meta: { ...(usersiU9ZD_45wuhKx_45Plc42o2wWmxRCqwWEZBmlz54n1JFVWwMeta || {}), ...{"middleware":["viewer-or-above"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/system/users.vue")
  },
  {
    name: "welcome-back",
    path: "/welcome/back",
    meta: {"middleware":["welcome-back"]},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/welcome/back.vue")
  },
  {
    name: "welcome-team",
    path: "/welcome/team",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/welcome/team.vue")
  },
  {
    name: "accept-invite",
    path: "/accept-invite",
    meta: accept_45inviteR847aZX2c8ws5tHf19TLxxa7C_45w8wYvuxaJLKo8zEzwMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/accept-invite.vue")
  },
  {
    name: "admin-anglers",
    path: "/admin/anglers",
    meta: { ...(anglerslOQ9vGYpZw95pDskLCm2cm2SpyronklZ6KowoDqqj6AMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/anglers.vue")
  },
  {
    name: "admin-auction",
    path: "/admin/auction",
    meta: { ...(auctionGdo5nFhTSb0wx8ngrax8s3Khla2_45UIhkuWvWonHsCe4Meta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/auction.vue")
  },
  {
    name: "admin-pending",
    path: "/admin/pending",
    meta: { ...(pendingrnWmT90_45W3LDJrEzFalh03ETEKseTuSpnsqrvf8V924Meta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/pending.vue")
  },
  {
    name: "admin-raffles",
    path: "/admin/raffles",
    meta: { ...(rafflesNoEzYnPbfiUqPpJmQ7gqwyx6o17e1PDHfzjU21HAT3kMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/raffles.vue")
  },
  {
    name: "admin-winners",
    path: "/admin/winners",
    meta: { ...(winnersRpyUx6RLROk_45XmbsMLUVOh36fNYn_459rG6giOzTup9EgMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/winners.vue")
  },
  {
    name: "honoree",
    path: "/honoree",
    meta: indexDtvu0oHXDMLsGiDB9sbM18IYpgw_pWVDCIHLyLNWGKsMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/honoree/index.vue")
  },
  {
    name: "judges-guests",
    path: "/judges/guests",
    meta: { ...(guestsRr3dfGUgn9TUyIxDjgTSyBOlouiT3KZ0It5ih_45XrbZIMeta || {}), ...{"middleware":["invited-to-year-only","judge-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/judges/guests.vue")
  },
  {
    name: "my-team",
    path: "/my-team",
    meta: { ...(indexdP4R1aFhMWEISVVQa3v3apv3EK0IIitNDZEDH1C6l6UMeta || {}), ...{"middleware":["invited-to-year-only","dashboard"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/my-team/index.vue")
  },
  {
    name: "raffles",
    path: "/raffles",
    meta: index5uy6CeGXd8PUlxRLM9QTUrVm0583zRtCOr4yc2xHaawMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/raffles/index.vue")
  },
  {
    name: "system-events",
    path: "/system/events",
    meta: { ...(eventszYSADN7hQ3zsdoumzACZs9JgDl_45rDojfTgemNCPriocMeta || {}), ...{"middleware":["system-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/system/events.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: {"middleware":["sponsor-only"]},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/welcome/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: {"middleware":["sponsor-only"]},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/checkout/index.vue")
  },
  {
    name: "invite-token",
    path: "/invite/:token()",
    meta: { ...(_91token_93I0imRa9GtTJnGCGnEcqMWs05UJUrU4_k0oPnc_452oC6kMeta || {}), ...{"middleware":["not-user-only","invite-check"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/invite/[token].vue")
  },
  {
    name: "judges-anglers",
    path: "/judges/anglers",
    meta: { ...(anglersq1TLzyLeW9OY7x3VeUq7ejKR2pBbB2PS5vJ_YlddWnYMeta || {}), ...{"middleware":["invited-to-year-only","judge-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/judges/anglers.vue")
  },
  {
    name: "judges-raffles",
    path: "/judges/raffles",
    meta: { ...(raffles9HR2LT8nw_Og233b7XhpNbVNAu_452My2GQmXbBdnY1bAMeta || {}), ...{"middleware":["invited-to-year-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/judges/raffles.vue")
  },
  {
    name: "judges-scoring",
    path: "/judges/scoring",
    meta: { ...(scoringZZktM9fHEOg9N3DE7STerszbn7ftvkThajb7jBibCJsMeta || {}), ...{"middleware":["invited-to-year-only","judge-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/judges/scoring.vue")
  },
  {
    name: "schedule",
    path: "/schedule",
    meta: { ...(indexKF_8C3UIr2gLzbYITdwRx5Wt3gO3AlKgnRP_v0EwSKgMeta || {}), ...{"middleware":["invited-to-year-only","dashboard"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/schedule/index.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    meta: { ...(dashboardeENnwqTvgTzkKXU6IdZT1SjD0Nn6iGyLu_wYuDBU3HYMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/dashboard.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(indexl13FyZ6426JkKiuKnrA0SYuntyBjuy5q5JbAxz8VuLQMeta || {}), ...{"middleware":["invited-to-year-only","dashboard"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/dashboard/index.vue")
  },
  {
    name: "thank-you",
    path: "/thank-you",
    meta: indexB9NYy_45_45XLIps4DRUut2BlGu2qbKLslDozUzdTs2dMHYMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/thank-you/index.vue")
  },
  {
    name: "welcome-sponsor",
    path: "/welcome/sponsor",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/welcome/sponsor.vue")
  },
  {
    name: "checkout_confirm",
    path: "/checkout_confirm",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/checkout_confirm.vue")
  },
  {
    name: "checkout-payment",
    path: "/checkout/payment",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/checkout/payment.vue")
  },
  {
    name: "new-welcome-back",
    path: "/new-welcome/back",
    meta: {"middleware":["welcome-back"]},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/new-welcome/back.vue")
  },
  {
    name: "new-welcome-team",
    path: "/new-welcome/team",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/new-welcome/team.vue")
  },
  {
    name: "public-rules-map",
    path: "/public/rules/map",
    meta: map6A_WM45sTWRGeXe7If6UjZnij0pKYeBE64ON0pmjIJ8Meta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/rules/map.vue")
  },
  {
    name: "testMember",
    path: "/testMember",
    meta: { ...(index_45N0e_4534jWyo9UfMUkLGIqju0zlVwjKzqWAydm9xZLMYMeta || {}), ...{"middleware":["dashboard"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/testMember/index.vue")
  },
  {
    name: "admin-tournaments",
    path: "/admin/tournaments",
    meta: { ...(tournamentscygxCB_45bYnMNYBDQ4uAqxH__45_45GZw3PTUbg5ecaw_5tAMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/tournaments.vue")
  },
  {
    name: "leaderboard",
    path: "/leaderboard",
    meta: { ...(indexCZhDpXlFXBs_M4FC2RCVPRZdXPqVVU1eP1h9qsdYbmEMeta || {}), ...{"middleware":["invited-to-year-only","dashboard"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/leaderboard/index.vue")
  },
  {
    name: "new-welcome",
    path: "/new-welcome",
    meta: {"middleware":["invited-to-year-only","sponsor-only"]},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/new-welcome/index.vue")
  },
  {
    name: "under-maintenance",
    path: "/under-maintenance",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/under-maintenance.vue")
  },
  {
    name: "admin-participants",
    path: "/admin/participants",
    meta: { ...(participantsOXXuPHWgQZ7DtvvSoDDTfENT40CFV1VToFI87CRoTaYMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/participants.vue")
  },
  {
    name: "public-rules",
    path: "/public/rules",
    meta: indexWheaOfWjtFmrlGeaP5SOpliyXdiVieTgEfE3QNRRNQ8Meta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/rules/index.vue")
  },
  {
    name: "admin-announcements",
    path: "/admin/announcements",
    meta: { ...(announcementsaPxj_FGJpPXVqjbOo823av6sZ2U5U5MqNHaRr0X2P4sMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/announcements.vue")
  },
  {
    name: "admin-raffle-buyers",
    path: "/admin/raffle-buyers",
    meta: { ...(raffle_45buyersccOgCjQ0CozrdJyZVcVt7UoRUAkW0hOb5fD6yadKiNoMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/raffle-buyers.vue")
  },
  {
    name: "admin-reel-of-names",
    path: "/admin/reel-of-names",
    meta: { ...(reel_45of_45namesJL5tpfBF2OqshZVya2uR2k3eqmp_yjT_45VtNxtC8Z82AMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/reel-of-names.vue")
  },
  {
    name: "announcements",
    path: "/announcements",
    meta: { ...(indexFjLVLyLuNd0cuV28AQ19xn1G3SEMo6vby0ILsskrp7cMeta || {}), ...{"middleware":["invited-to-year-only","dashboard"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/announcements/index.vue")
  },
  {
    name: "team-picker-preview",
    path: "/team-picker-preview",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/team-picker-preview.vue")
  },
  {
    name: "admin-random-winners",
    path: "/admin/random-winners",
    meta: { ...(random_45winnerst0AxritM8Zj7zLTZNdY0VXQNCdzn6FRLitd_45eoyhY9oMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/random-winners.vue")
  },
  {
    name: "invite-event-token",
    path: "/invite/event/:token()",
    meta: { ...(_91token_93rAEwAEXIZMNZglAhDJZB6kLFmA5CVcbg97FNQlIZ0A8Meta || {}), ...{"middleware":["not-user-only","event-invite-check"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/invite/event/[token].vue")
  },
  {
    name: "invite-judge-token",
    path: "/invite/judge/:token()",
    meta: { ...(_91token_93flB_45mo28k2NkoUrWGjgi0g57FnrDvZoGFUU2ey9NA_45AMeta || {}), ...{"middleware":["not-user-only","invite-check"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/invite/judge/[token].vue")
  },
  {
    name: "invite-leader-token",
    path: "/invite/leader/:token()",
    meta: { ...(_91token_93MovRuF0T_45fIFnombBWv1RY_GZ_456RH4UX24TwML8a1swMeta || {}), ...{"middleware":["not-user-only","invite-check"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/invite/leader/[token].vue")
  },
  {
    name: "invite-member-token",
    path: "/invite/member/:token()",
    meta: { ...(_91token_93lt1qTgNRU6SCJ0Q2A1C734IcKop6Lp7lTjw2s7mJTloMeta || {}), ...{"middleware":["not-user-only","invite-check"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/invite/member/[token].vue")
  },
  {
    name: "invite-system-token",
    path: "/invite/system/:token()",
    meta: { ...(_91token_93BDpvEb7vma9lx_45T7jgzoyP12jPDLn3YeV1sblzEoJmwMeta || {}), ...{"middleware":["not-user-only","invite-check"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/invite/system/[token].vue")
  },
  {
    name: "welcome-vendor-inquiry",
    path: "/welcome/vendor-inquiry",
    meta: vendor_45inquiryJ18XWZX_45rVy07s5zTMOE6X3w1uiPbo_45Zy_45rweFacDGkMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/welcome/vendor-inquiry.vue")
  },
  {
    name: "welcome-industry-vendor",
    path: "/welcome/industry-vendor",
    meta: {"middleware":["sponsor-only"]},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/welcome/industry-vendor.vue")
  },
  {
    name: "admin-tournament-invites",
    path: "/admin/tournament-invites",
    meta: { ...(tournament_45inviteslo27kKEV7_45KRn_CkV4G_45Ndt3fyAReiGUE34hVzzhBHoMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/tournament-invites.vue")
  },
  {
    name: "public-leaderboard",
    path: "/public/leaderboard",
    meta: indexnkJay2wS1ZYDfBCEQn_J64YiBrmQqayFcC1X8IIrh6UMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/leaderboard/index.vue")
  },
  {
    name: "public-leaderboard-event",
    path: "/public/leaderboard/:event()",
    meta: _91event_93zdUVOTBFZkCtVW6kzpapKN1L7GgjlFsJRxcL_45t_PEjwMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/leaderboard/[event].vue")
  },
  {
    name: "public-raffle-label-id",
    path: "/public/raffle/:label()/:id()",
    meta: _91id_93w2Qg4Fa9p8o2sZc91XxEnAgdjDiPWm_45xQDNGx60cH4gMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/raffle/[label]/[id].vue")
  },
  {
    name: "admin-registration-overview",
    path: "/admin/registration/overview",
    meta: { ...(overviewkSADNhXUgLrZ4nKyt6w7VTgEJ3fX_hkYv6VAfd7JU6YMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/registration/overview.vue")
  },
  {
    name: "admin-registration-payments",
    path: "/admin/registration/payments",
    meta: { ...(paymentsp3cucG9WDlAG4j4po4t7ynebWTVgzBVHQAg6hdsDtKYMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/registration/payments.vue")
  },
  {
    name: "admin-registration-waitlist",
    path: "/admin/registration/waitlist",
    meta: { ...(waitlistnqeJbD68oYzT31_45hGa7NvC_IKH9SRB2xT78emkPtjboMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/registration/waitlist.vue")
  },
  {
    name: "new-welcome-industry-vendor",
    path: "/new-welcome/industry-vendor",
    meta: {"middleware":["sponsor-only"]},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/new-welcome/industry-vendor.vue")
  },
  {
    name: "public-raffle-label",
    path: "/public/raffle/:label()",
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/raffle/[label]/index.vue")
  },
  {
    name: "admin-registration-donations",
    path: "/admin/registration/donations",
    meta: { ...(donationsOgelWXY9DwQHfO4w6v34wujj_45Wy9FTRWcmxfU26h_yoMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/registration/donations.vue")
  },
  {
    name: "public-auction-label",
    path: "/public/auction/:label()",
    meta: indexcPcwOxuGARjQ2Zu7TQ_45TnP85c_ut4zObGzA0uXVxOqEMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/auction/[label]/index.vue")
  },
  {
    name: "admin-registration-donor-invites",
    path: "/admin/registration/donor-invites",
    meta: { ...(donor_45invitesGTBq3BbA30G9w_hJC8x91CrifK6LyK0_45OglZV8ab7tgMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/registration/donor-invites.vue")
  },
  {
    name: "public-auction-label-priority",
    path: "/public/auction/:label()/:priority()",
    meta: _91priority_93UtihjiD4VDCZ1dQwKkFoa0mUDYv8_45SIhXoRBM_45yzQ2cMeta || {},
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/public/auction/[label]/[priority].vue")
  },
  {
    name: "admin-registration-vendor-inquiries",
    path: "/admin/registration/vendor-inquiries",
    meta: { ...(vendor_45inquiriesoetnxe3hhKYP4voix0fUgqnpdHsS35f4U_45u3G5aQPVsMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/opt/buildagent/work/9e6a59290f45540b/apps/frontend/pages/admin/registration/vendor-inquiries.vue")
  }
]